var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 172.7 172.7",
    style: {
      enableBackground: "new 0 0 172.7 172.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#2C2C2C;}\n\t.st1{display:none;fill:#3B086B;}\n\t.st2{fill:#3B086B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.8,106.2c-3.9,0-7.1-3.2-7-7.1c0,0,0-0.1,0-0.1V13.3H29.4c-4,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2h137.4 c3.9,0,7.1,3.2,7,7.1c0,0,0,0.1,0,0.1V99C173.9,102.9,170.7,106.2,166.8,106.2L166.8,106.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.8,103.4c-2.3,0-4.2-1.9-4.2-4.2l0-88.7H29.4c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4h137.4 c1.1,0,2.2,0.4,3,1.2c0.8,0.8,1.2,1.9,1.2,3l0,93.1C171,101.4,169.2,103.3,166.8,103.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.8,102.7c-1.9,0-3.5-1.6-3.5-3.5l0-89.4H29.4c-2,0-3.7-1.6-3.7-3.7s1.6-3.7,3.7-3.7h137.4 c0.9,0,1.8,0.4,2.5,1c0.7,0.7,1,1.6,1,2.5l0,93.1C170.3,101,168.8,102.6,166.8,102.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.8,102c-1.5,0-2.8-1.3-2.8-2.8L164,9H29.4c-1.6,0-3-1.3-3-3s1.3-3,3-3h137.4c0.7,0,1.4,0.3,2,0.8 c0.5,0.5,0.8,1.2,0.8,2l0,93.1C169.6,100.6,168.4,101.9,166.8,102z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.2,173.9c-1.9,0-3.7-0.8-5-2.2c-2.8-2.8-2.9-7.3-0.1-10.2c0,0,0.1-0.1,0.1-0.1L74,118.5 c1.3-1.3,3.1-2.1,5-2.2h53.4v-78H13.3v78h19.3c4,0.1,7.2,3.4,7.1,7.4c-0.1,3.9-3.2,7-7.1,7.1H6.1c-4,0-7.2-3.1-7.2-7.1 c0,0,0-0.1,0-0.1V31.1c0-4,3.1-7.2,7.1-7.2c0,0,0.1,0,0.1,0h133.8c2,0,3.8,0.8,5.2,2.2c1.4,1.4,2.1,3.3,2,5.2l-0.3,92.4 c-0.1,3.9-3.3,7-7.2,7.1H82.1l-40.7,40.8C40.1,173,38.2,173.8,36.2,173.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,171c-1.1,0-2.1-0.5-2.9-1.3l-0.1-0.1c-1.7-1.7-1.7-4.4-0.1-6.2l43-43c0.8-0.8,1.9-1.3,3.1-1.3l56.2,0 V35.5H10.5v83.6h22.2c2.4,0,4.3,2.1,4.2,4.5c0,2.4-1.9,4.3-4.3,4.3l-26.5,0c-2.4,0-4.4-1.9-4.4-4.3V31.1c0-1.2,0.4-2.3,1.2-3.1 s1.9-1.3,3-1.3c0,0,133.9,0,133.9,0c1.2,0,2.4,0.5,3.1,1.3l0.1,0.1c0.8,0.8,1.2,1.9,1.2,3l0,0.2l-0.3,92.4c-0.1,2.3-2,4.2-4.4,4.3 l-58.6,0l-41.6,41.7C38.5,170.5,37.4,171,36.1,171L36.1,171z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.1,170.3c-0.9,0-1.8-0.4-2.4-1l-0.1-0.1c-0.7-0.7-1.1-1.6-1.1-2.6s0.4-1.9,1-2.6l43-43 c0.7-0.7,1.6-1.1,2.6-1.1l56.9,0V34.8H9.7v85.1h22.9c2,0,3.6,1.7,3.5,3.8c0,2-1.6,3.6-3.6,3.6l-26.5,0c-2,0-3.6-1.6-3.7-3.6V31.1 c0-1,0.4-1.9,1-2.6S5,27.4,6,27.4l133.9,0c1,0,2,0.4,2.6,1.1l0.1,0.1c0.7,0.6,1,1.5,1,2.4l0,0.2l-0.3,92.5c-0.1,2-1.7,3.5-3.7,3.6 l-58.9,0l-41.8,41.9C38.1,169.9,37.2,170.3,36.1,170.3L36.1,170.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,169.6c-0.7,0-1.4-0.3-1.8-0.8l-0.1-0.1c-0.6-0.6-0.9-1.3-0.9-2.1s0.3-1.5,0.8-2.1l43-43 c0.6-0.6,1.3-0.9,2.1-0.9l57.6,0V34.1H9v86.5h23.6c1.6,0,2.9,1.4,2.8,3c0,1.6-1.3,2.9-2.9,2.9l-26.5,0c-1.6,0-2.9-1.3-3-2.9V31.1 c0-0.8,0.3-1.5,0.8-2.1c0.5-0.6,1.3-0.9,2-0.9l133.9,0c0.8,0,1.6,0.3,2.1,0.9l0.1,0.1c0.5,0.5,0.8,1.2,0.8,1.9l0,0.2l-0.3,92.5 c0,1.5-1.4,2.8-3,2.8l-59.1,0l-42,42.1C37.7,169.3,37,169.6,36.1,169.6L36.1,169.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk);
export default __webpack_public_path__ + "static/media/talk.6c7954e449d27b80931323f59844c045.svg";
export { ForwardRef as ReactComponent };